import {
  FETCH_BATTERY_LEVEL_REQUEST,
  FETCH_BATTERY_LEVEL_SUCCESS,
  FETCH_BATTERY_LEVEL_FAILURE,
} from './types';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const batteryLevelReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_BATTERY_LEVEL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_BATTERY_LEVEL_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case FETCH_BATTERY_LEVEL_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default batteryLevelReducer;
